<template>
    <div>
        <b-card-group columns class="two-columns">
            <post-card
                v-if="userHasPost"
                :key="userPost.id"
                :display-name="userPost.display_name"
                :date="userPost.humanDate"
                :description="userPost.description"
                :post-id="userPost.id"
                :reaction="userPost.reaction"
                :likes="userPost.likes"
                :color="userPost.color"
                :is-user-post="true"
                :delete-post="onDeletePost"
                :edit-post="onEditPost"
                :like-post="onLikePost"
            />
            <post-card 
                v-for="post in posts"
                :key="post.id"
                :is-user-post="false"
                :display-name="post.display_name"
                :date="post.humanDate"
                :description="post.description"
                :post-id="post.id"
                :reaction="post.reaction"
                :likes="post.likes"
                :color="post.color"
                :like-post="onLikePost"
            >
                <template v-slot:translations>
                    <post-translation-container
                        descriptionOnly
                        :post-id="post.id"
                        :title-locale="post.title_locale"
                        :description-locale="post.description_locale"
                    />
                </template>
            </post-card>
        </b-card-group>
    </div>
</template>

<script>
    import PostCard from "../molecules/cards/PostCard";
    import AddPostCard from "../molecules/AddPostCard";
    import PostCommunityModal from "./PostCommunityModal";
    import PostTranslationContainer from "../organisms/PostTranslationContainer"

    export default {
        name: "CommunityMasonry",
        components: {PostCard, AddPostCard, PostCommunityModal, PostTranslationContainer},
        props: {
            posts: Array,
            moduleId: Number,
            userPost: Object,
            userHasPost: Boolean,
            onLikePost: Function
        },
        methods:{
            onEditPost(){
                this.$emit('editUserPost');
                this.$root.$emit('bv::show::modal', 'post-community-modal', '#postButton')
            },
            onDeletePost(){
                this.$emit('onDelete')
            }
        }
    }
</script>

<style scoped>
    .two-columns{
        column-count: 2;
    }

    @media(max-width: 768px){
        .two-columns{
            column-count: 1 !important;
        }
    }
</style>
